// extracted by mini-css-extract-plugin
export default {"submenu-wrapper":"SubmenuWrapper__submenu-wrapper___AkZPQ","new-button":"SubmenuWrapper__new-button___LdfI3","new-button-focused":"SubmenuWrapper__new-button-focused___Dl3LY"};